import * as React from "react";

import i18next from "i18next";

import { IconWrapper, Nav, StyledNavLink } from "./styles";
import { FileIcon } from "../../svg";

type Props = {
  children: React.ReactNode;
};

const DataLoaderMenu = ({ children }: Props) => {
  return (
    <>
      <Nav.Item>
        <StyledNavLink to="/data-load">
          <IconWrapper>
            <FileIcon />
          </IconWrapper>
          {i18next.t("load_data")}
        </StyledNavLink>
      </Nav.Item>

      {children}
    </>
  );
};

export default DataLoaderMenu;
